export class UserLoginEvent {
  static eventName = "event:user-login";

  constructor({ location }) {
    this.eventName = UserLoginEvent.eventName;
    console.log("UserLoginEvent created for location:", this.eventName);
    this.location = location;
    console.log("UserLoginEvent location:", this.location);
  }
}
